import React from 'react';

export const IconSearch = (
  <svg id="Icon_Search_Rounded" data-name="Icon / Search / Rounded" xmlns="http://www.w3.org/2000/svg" width="26.731" height="26.731" viewBox="0 0 26.731 26.731">
    <rect id="Box" width="26.731" height="26.731" fill="none"/>
    <path id="Path_2019" data-name="Path 2019" d="M152.145,13.246a5.012,5.012,0,1,1,5.012-5.012A4.991,4.991,0,0,1,152.145,13.246Zm6.683,0h-.891l-.334-.334a7.343,7.343,0,0,0,1.671-5.9,7.207,7.207,0,0,0-6.237-5.9,7.272,7.272,0,0,0-2.228,14.368,7.343,7.343,0,0,0,5.9-1.671l.334.334v.891l4.678,4.678a1.181,1.181,0,1,0,1.671-1.671Z" transform="translate(-141.675 2.347)" fill="#b2b2b2"/>
  </svg>
);
